export default __webpack_public_path__ + "static/media/cover-img.b4faa0df.jpg";